import React, { useEffect, useState, useContext, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
// import Tab from 'react-bootstrap/Tab';
import Tabs from "react-bootstrap/Tabs";
import PartnersOnline from "../../images/newIcon/Online Individual_Non-Individual Empanelment 1.svg";
import Partnersoffline from "../../images/newIcon/Offline Empanelment 1.svg";
import PartnerTransact from "../../images/newIcon/Transaction Platform 1.svg";
import GenerateEasyLink from "../../images/newIcon/Generate Easy Link.svg";
import ProcessandServices from "../../images/newIcon/Process and Services 1.svg";
// import OnlineNonIndividualEmpanelment from "../../images/OnlineNonIndividualEmpanelment.png";
import CoBranded from "../../images/newIcon/Co-Branded Collaterals 1.svg";
// import { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import "../PartnersCorner/PartnersCorner.css";
import PartnersBanner from "./PartnersBanner/PartnersBanner";
import OfflineEmpanelment from "./OfflineEmpanelment/OfflineEmpanelment";
import KnowDistributer from "./KnowDistributer/KnowDistributer";
import URLstateContext from "../../provider/CommonContext";
// import { Helmet } from "react-helmet";
import { trackEvent, trackPageView } from "../utils/tracking";
import { Helmet, HelmetProvider } from "react-helmet-async";
// import { Tabs } from "@mui/material";

function PartnersCorner(props) {
  const offlineEmpanelmentRef = useRef(null);
  const processAndServicesRef = useRef(null);
  const [value, setValue] = React.useState("3");
  const [key, setKey] = useState("3");
  const [pathnamenew, setPathName] = useState("");
  const [liveMessage, setLiveMessage] = useState("");
  const { fontSize, changeFontSize, resetFontSize, changeFontSizeMinus } =
    useContext(URLstateContext);

  // alert(value)

  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/PartnersCorner",
      "jmf_partnerscorner",
    );
    // trackPageView(
    //   "http://localhost:710/PartnersCorner",
    //   "jmf_partnerscorner"
    // );

    trackEvent({
      category: "Static Page",
      action: "Partner Corner Page Loaded",
      label: "jmf_partnerscorner",
      // value: 1,
    });
  }, []);

  const arrayOfTabsObj = [
    {
      name: "Online Individual / Non-Individual Empanelment",
      img: PartnersOnline,
      id: 1,
    },
    // { name: "Online Non-Individual Empanelment", img: OnlineNonIndividualEmpanelment, id: 7 },
    {
      name: "Offline Empanelment",
      img: Partnersoffline,
      tab: <OfflineEmpanelment />,
      id: 2,
    },
    { name: "Transaction Platform", img: PartnerTransact, id: 3 },
    {
      name: "Generate Easy Link",
      text: "A smarter way to help your investors invest with us. You can now generate a fund investment link under your ARN.",
      img: GenerateEasyLink,
      id: 4,
    },
    {
      name: "Process and Services",
      img: ProcessandServices,
      tab: <KnowDistributer />,
      id: 5,
    },
    { name: "Co-Branded Collaterals", img: CoBranded, id: 6 },
    // {
    //   name : "MFD Resources",
    //   img :CoBranded,
    //   id : 8,
    // }
    // {img:PartnersOnline,id:1},
    // {img:Partnersoffline,id:2}
  ];

  
  // const handleChange = (k) => {
  //   if (k === "2") {
  //     setValue("2");
  //     setKey("2");
  //     offlineEmpanelmentRef.current.scrollIntoView({ behavior: "smooth" });
  //   } else if (k === "5") {
  //     setValue("5");
  //     setKey("5");
  //     processAndServicesRef.current.scrollIntoView({ behavior: "smooth" });
  //   }
  //   if (k === "1") window.open("https://onboarding.jmfinancialmf.com/login");
  //   if (k === "3") window.open("https://dit.jmfinancialmf.com/portal/login");
  //   if (k === "4") window.open("https://dit.jmfinancialmf.com/easylink");
  //   // if (k === "6")
  //   //   window.open("https://docviewer.jmfinancialmf.com/cobranded/");
  //   if (k === "6") window.open("https://jmcobrand.anchoredgetechno.com/");
  //   if (k === "7") window.open("https://onboarding.jmfinancialmf.com");
  // };

  const handleChange = (k) => {
  const tabItem = arrayOfTabsObj.find((item) => item.id === parseInt(k));

  if (k === "2") {
    setValue("2");
    setKey("2");
  } else if (k === "5") {
    setValue("5");
    setKey("5");
  } else if (k === "1") {
    window.open("https://onboarding.jmfinancialmf.com/login", "_blank");
    return; // No need to change tab
  } else if (k === "3") {
    window.open("https://dit.jmfinancialmf.com/portal/login", "_blank");
    return;
  } else if (k === "4") {
    window.open("https://dit.jmfinancialmf.com/easylink", "_blank");
    return;
  } else if (k === "6") {
    window.open("https://jmcobrand.anchoredgetechno.com/", "_blank");
    return;
  } else if (k === "7") {
    window.open("https://onboarding.jmfinancialmf.com", "_blank");
    return;
  }

  // For tabs that show content (especially 2 and 5)
  setTimeout(() => {
    let targetRef = null;
    let panelId = `tabpanel-${k}`;

    if (k === "2") {
      targetRef = offlineEmpanelmentRef;
    } else if (k === "5") {
      targetRef = processAndServicesRef;
    }

    // 1. Focus the tab panel
    const activePanel = document.getElementById(panelId) || 
                       (targetRef?.current);

    if (activePanel) {
      activePanel.setAttribute("tabindex", "-1"); // Make focusable
      activePanel.focus({ preventScroll: true });
    }

    // 2. Announce to screen readers
    if (tabItem) {
      setLiveMessage(`Switched to ${tabItem.name}`);
      
      // Clear message after announcement
      setTimeout(() => setLiveMessage(""), 1500);
    }

    // 3. Smooth scroll (keep your existing behavior)
    if (targetRef?.current) {
      targetRef.current.scrollIntoView({ 
        behavior: "smooth", 
        block: "start" 
      });
    }
  }, 100); // Small delay to let React render the new content
};


  
  // useEffect(() => {
  //   if (value === "2") {
  //     offlineEmpanelmentRef.current.scrollIntoView({ behavior: "smooth" });
  //   } else if (value === "5") {
  //     processAndServicesRef.current.scrollIntoView({ behavior: "smooth" });
  //   }

  //   if (window.location.pathname.split("/")[2] === "OfflineEmpanelment") {
  //     offlineEmpanelmentRef.current.scrollIntoView({ behavior: "smooth" });
  //   } else if (window.location.pathname.split("/")[2] === "ProcessAndService") {
  //     processAndServicesRef.current.scrollIntoView({ behavior: "smooth" });
  //   }
  // }, [value]);


  useEffect(() => {
  if (value === "2" || value === "5") {
    const targetRef = value === "2" ? offlineEmpanelmentRef : processAndServicesRef;
    
    if (targetRef?.current) {
      // Scroll
      targetRef.current.scrollIntoView({ 
        behavior: "smooth", 
        block: "start" 
      });

      // Focus + announce on initial load / URL navigation
      setTimeout(() => {
        const panelId = `tabpanel-${value}`;
        const panel = document.getElementById(panelId) || targetRef.current;
        
        if (panel) {
          panel.setAttribute("tabindex", "-1");
          panel.focus({ preventScroll: true });
        }

        const tabItem = arrayOfTabsObj.find(item => item.id === parseInt(value));
        if (tabItem) {
          setLiveMessage(`Loaded ${tabItem.name}`);
          setTimeout(() => setLiveMessage(""), 1200);
        }
      }, 300);
    }
  }
}, [value]);

  useEffect(() => {
    const pathname = window.location.pathname;
    const lastSegment = pathname.slice(pathname.lastIndexOf("/") + 1);
    const CategoryIdUrlid = lastSegment;

    setPathName(pathname);
    //  alert(CategoryIdUrlid)
    // setloadingshow(true);
    if (CategoryIdUrlid === "OfflineEmpanelment") {
      setValue("2");
      setKey("2");
    } else if (CategoryIdUrlid === "ProcessAndService") {
      setValue("5");
      setKey("5");
    }

    var para = window.location.pathname.toLocaleLowerCase().split("/")[2];
    if (para === "onlineempanelment") setValue(1);
    if (para === "offlineempanelment") setValue(2);
    if (para === "transactionplatform") setValue(3);
    if (para === "generateeasylink") setValue(4);
    if (para === "processandservice") setValue(5);
  }, []);

  useEffect(() => {
    const makeAllTabsFocusable = () => {
      document.querySelectorAll(".nav-tabs .nav-link").forEach((button) => {
        button.setAttribute("tabindex", "0");
      });
    };

    makeAllTabsFocusable();

    // Watch for any DOM changes in the tab area
    const observer = new MutationObserver(makeAllTabsFocusable);
    const tabsContainer = document.querySelector(".nav-tabs");

    if (tabsContainer) {
      observer.observe(tabsContainer, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }

    return () => observer.disconnect();
  }, [key]);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta charset="UTF-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta
            name="description"
            content="Access tools, resources, and support for distributors and advisors at JM Financial Mutual Fund’s Partners Corner. Empower your clients with seamless investment solutions."
          />
          <meta
            name="keywords"
            content="jmf_partnerscorner, JM Financial Mutual Fund, partners corner, investment"
          />
          <title>
            Partners Corner | Resources for Distributors and Advisors | JM
            Financial Mutual Fund
          </title>
        </Helmet>
      </HelmetProvider>

      <PartnersBanner id={value} />

      <main id="main-content" tabIndex="-1">
        {/* <h1 className="sr-only">
            Partners Corner
         </h1> */}
        <section
          className="partners-tabs"
          style={{ fontSize: `${fontSize}px` }}
        >
          <Container>
            <Row>
              <Col>
                <nav aria-label="Breadcrumb">
                  <ol className="navigator-arrow">
                    <li>
                      <a href="/" aria-label="Home">
                        <i className="fa fa-home"></i>
                        <span className="sr-only">Home</span>
                      </a>

                      <i className="fa fa-angle-right"></i>
                    </li>
                    <li>
                      <a href="/PartnersCorner">Partner Corner</a>{" "}
                      <i class="fa fa-angle-right"></i>
                    </li>
                    {/* <li>Calculator</li><i class="fa fa-angle-right" aria-hidden="true"></i> */}
                    {window.location.pathname != "/PartnersCorner" ? (
                      <li>
                        {" "}
                        {pathnamenew
                          .slice(pathnamenew.lastIndexOf("/") + 1)
                          .replace(/([a-z])([A-Z])/g, "$1 $2")}
                      </li>
                    ) : null}
                  </ol>
                </nav>
              </Col>
            </Row>
          </Container>

          <TabContext value={value}>
            <Container>
              <Row>
                <Col sm={12}>
                  <Tabs
                    activeKey={key}
                    onSelect={handleChange}
                    id="uncontrolled-tab-example"
                    className="mb-3"
                  >
                    {arrayOfTabsObj.map((item) => (
                      // <Tab title={<span><img src={item.img} />{item.name}</span>} eventKey={item.id}>{item.tab}</Tab>
                      // <Tab
                      //   title={
                      //     <span style={{ fontSize: "14px" }}>
                      //       <img src={item.img} alt="tabImage" className="tab-icon"/>
                      //       {item.name}
                      //       {item.id === 4 ? (
                      //         <p className="hoverText">{item.text}</p>
                      //       ) : (
                      //         ""
                      //       )}
                      //     </span>
                      //   }
                      //   eventKey={item.id}
                      //   tabIndex={0}
                      // >
                      //   {item.id === 2 && (
                      //     <div ref={offlineEmpanelmentRef}>{item.tab}</div>
                      //   )}
                      //   {item.id === 5 && (
                      //     <div ref={processAndServicesRef}>{item.tab}</div>
                      //   )}
                      // </Tab>
                      <Tab
                        title={
                          <span style={{ fontSize: "14px" }}>
                            <img
                              src={item.img}
                              alt=""
                              aria-hidden="true"
                              className="tab-icon"
                              width={88}
                              height={88}
                            />
                            {item.name}
                            {item.id === 4 ? (
                              <p className="hoverText">{item.text}</p>
                            ) : (
                              ""
                            )}
                          </span>
                        }
                        eventKey={item.id}
                        ref={(tabElement) => {
                          if (tabElement) {
                            // React-Bootstrap renders the tab as a button inside
                            const button =
                              tabElement.querySelector("button.nav-link");
                            if (button) {
                              button.setAttribute("tabindex", "0");
                            }
                          }
                        }}
                      >
                        {item.id === 2 && (
                          <div
                            ref={offlineEmpanelmentRef}
                            id="tabpanel-2"
                            role="tabpanel"
                            aria-labelledby="uncontrolled-tab-example-tab-2"
                            tabIndex={0} // Allow focus if user wants to go there
                          >
                            {item.tab}
                          </div>
                        )}
                        {item.id === 5 && (
                          <div
                            ref={processAndServicesRef}
                            id="tabpanel-5"
                            role="tabpanel"
                            aria-labelledby="uncontrolled-tab-example-tab-5"
                            tabIndex={0}
                          >
                            {item.tab}
                          </div>
                        )}
                      </Tab>
                    ))}
                  </Tabs>
                </Col>
              </Row>
            </Container>
          </TabContext>

          <div
            aria-live="polite"
            aria-atomic="true"
            className="visually-hidden" // or use your existing sr-only class
            id="tab-live-region"
          >
            {liveMessage}
          </div>
          <div class="sticky-icon">
            <div id="fixed-social">
              <div>
                <div class="fixed-tumblr box">
                  <i class="fa fa-envelope"></i>
                  <span>
                    <a href="mailto:partnercare@jmfl.com">
                      partnercare@jmfl.com
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default PartnersCorner;
